import { Component } from "react";
import LanguageSelector from "./../../../../../../../NativeLanguageSelector/NativeLanguageSelector";
import Textarea from "./../../../../../../../formElements/Textarea/Textarea";
import TalaeraSpinner from "./../../../../../../../TalaeraSpinner/TalaeraSpinner";
import rtlDetect from "rtl-detect";

export default class TranslationInput extends Component {
  constructor(props) {
    super(props);

    this.isRtlLanguage = rtlDetect.isRtlLang(this.props.lang);
  }

  componentWillUpdate(nextProps) {
    if (nextProps.lang !== this.props.lang) {
      this.isRtlLanguage = rtlDetect.isRtlLang(nextProps.lang);
    }
  }

  render() {
    return (
      <div className="translation-input">
        <LanguageSelector value={this.props.lang} onChange={this.props.onLangChanged} />
        {this.props.showSpinner && (
          <div className="spinner-container">
            <TalaeraSpinner />
          </div>
        )}
        {!this.props.showSpinner && (
          <Textarea
            value={this.props.value}
            placeholder={this.props.placeholder}
            maxLength={this.props.maxLength}
            readOnly={this.props.readOnly}
            disabled={this.props.disabled}
            onChange={this.props.onTextChanged}
            rtl={this.isRtlLanguage}
          />
        )}
      </div>
    );
  }
}
